import config from "constants/configs";

const ListMenu = [
  {
    name: "Báo cáo tổng quan",
    code: "baocaotongquan",
    link: config.mormanServer + "tong-chi-nhanh/bao-cao-tong-quan.aspx",
    icon: "fas fa-chart-bar font-menu",
  },
  {
    name: "Nợ phải thu",
    code: "nophaithu",
    link: config.mormanServer + "trang-chu/no-phai-thu.aspx",
    icon: "fas fa-comment-dollar font-menu",
  },

  {
    name: "Đóng tiền nhanh",
    code: "dongtiennhanh",
    link: config.mormanServer + "trang-chu/dong-ho-nhanh.aspx",
    icon: "fas fa-comment-dollar font-menu",
  },
  {
    name: "Cầm đồ",
    code: "camdo",
    link: "/trang-chu/cam-do.aspx",
    icon: "la la-share-alt",
  },
  {
    name: "Tín chấp",
    code: "laingay",
    link: config.mormanServer + "trang-chu/tin-chap.aspx",
    icon: "la la-share-alt",
  },
  {
    name: "Trả góp",
    code: "laiho",
    link: config.mormanServer + "trang-chu/tra-gop.aspx",
    icon: "la la-share-alt",
  },
  {
    name: "Bán hàng trả góp",
    code: "banhangtragop",
    link: config.mormanServer + "trang-chu/ban-hang-tra-gop.aspx",
    icon: "la la-share-alt",
  },
  {
    name: "Danh sách nợ xấu",
    code: "danhsachnoxau",
    link: "#danhsachnoxau",
    icon: "fas fa-comment-dollar font-menu",
    subItems: [
      {
        name: "Cầm đồ",
        code: "danhsachnoxaucamdo",
        link: config.mormanServer + "trang-chu/danh-sach-no-xau/cam-do.aspx",
        icon: "la la-share-alt",
      },
      {
        name: "Tín chấp",
        code: "danhsachnoxautinchap",
        link: config.mormanServer + "trang-chu/danh-sach-no-xau/tin-chap.aspx",
        icon: "la la-share-alt",
      },
      {
        name: "Trả góp",
        code: "danhsachnoxautragop",
        link: config.mormanReact + "trang-chu/danh-sach-no-xau/tra-gop.aspx",
        icon: "la la-share-alt",
      },
    ],
  },
  {
    name: "Quản lý mua bán",
    code: "quanlymuaban",
    link: "#quanlymuaban",
    icon: "fas fa-home font-menu",
    subItems: [
      {
        name: "Nhập hàng",
        code: "nhaphang",
        link: config.mormanServer + "trang-chu/quan-ly-mua-ban/mua-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Bán hàng",
        code: "nhaphang",
        link: config.mormanServer + "trang-chu/quan-ly-mua-ban/ban-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Công nợ bán hàng",
        code: "quanlycongnobanhang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-mua-ban/cong-no-ban-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Lợi nhuận bán hàng",
        code: "loinhuanbanhang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-mua-ban/loi-nhuan-ban-hang.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý khách hàng",
    code: "quanlykhachhang",
    link: "#quanlykhachhang",
    icon: "far fa-address-card font-menu",
    subItems: [
      {
        name: "Danh sách khách hàng",
        code: "danhsachkhachhang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-khach-hang/danh-sach-khach-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Check thông tin khách hàng",
        code: "checkthongtinkhachhang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-khach-hang/check-thong-tin-khach-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Kiểm tra nợ xấu",
        code: "quanlykhachhang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-khach-hang/check-no-xau.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý đa cửa hàng",
    code: "quanlydacuahang",
    link: "#quanlydacuahang",
    icon: "fas fa-home font-menu",
    subItems: [
      {
        name: "Danh sách cửa hàng",
        code: "danhsachcuahang",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-cua-hang/danh-sach-cua-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Tổng quát cửa hàng",
        code: "tongquatcuahang1",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-da-cua-hang/tong-quat-cua-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Chi tiết cửa hàng",
        code: "chitietcuahang1",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-da-cua-hang/chi-tiet-cua-hang.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý tài sản",
    code: "quanlytaisan",
    link: "#quanlytaisan",
    icon: "fas fa-car-side font-menu",
    subItems: [
      {
        name: "Danh sách tài sản",
        code: "danhsachtaisan",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-tai-san/danh-sach-tai-san.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách kho",
        code: "danhsachkho",
        link:
          config.mormanServer + "trang-chu/quan-ly-tai-san/danh-sach-kho.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Công Nợ thanh lý",
        code: "congnothanhly",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-tai-san/cong-no-thanh-ly.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách thanh lý",
        code: "danhsachthanhly",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-tai-san/danh-sach-thanh-ly.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Kiểm kho",
        code: "kiemkho",
        link: config.mormanServer + "trang-chu/quan-ly-tai-san/kiem-kho.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách kiểm kho",
        code: "danhsachkiemkho",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-tai-san/danh-sach-kiem-kho.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Tài sản công ty",
        code: "taisancongty",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-tai-san/danh-sach-tai-san-cong-ty.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Tài khoản Icloud",
        code: "taikhoanicloud_danhsach",
        link:
          config.mormanReact +
          "trang-chu/quan-ly-tai-san/tai-khoan-icloud.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý nhân viên",
    code: "quanlynhanvien",
    link: "#quanlynhanvien",
    icon: "fas fa-users-cog font-menu",
    subItems: [
      {
        name: "Danh sách nhân viên",
        code: "danhsachnhanvien",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-nhan-vien/danh-sach-nhan-vien.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Quản lý công việc",
        code: "quanlycongviec",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-nhan-vien/quan-ly-cong-viec.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý thu chi",
    code: "quanlythuchi",
    link: "#quanlythuchi",
    icon: "fas fa-coins font-menu",
    subItems: [
      {
        name: "Thu/Chi hợp đồng",
        code: "thuchihopdong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-thu-chi/thu-chi-hop-dong.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Trích lập dự phòng",
        code: "trichlapduphong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-thu-chi/trich-lap-du-phong.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thu/Chi ngoài lề",
        code: "thuchingoaile",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-thu-chi/thu-chi-ngoai-le.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý nguồn vốn",
    code: "quanlynguonvonnew",
    link: "#quanlynguonvonnew",
    icon: "fas fa-donate font-menu",
    subItems: [
      {
        name: "Huy động vốn",
        code: "nhanvay",
        link: config.mormanServer + "trang-chu/quan-ly-nguon-von/nhan-vay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Vốn cổ đông",
        code: "quanlynguonvon",
        link:
          config.mormanServer + "trang-chu/quan-ly-nguon-von/nguon-von.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Thống kê",
    code: "thongke",
    link: "#thongke",
    icon: "fas fa-chart-line font-menu",
    subItems: [
      {
        name: "Thu dự kiến",
        code: "thudukien",
        link: config.mormanServer + "trang-chu/thong-ke/thu-du-kien.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thu",
        code: "thu",
        link: config.mormanServer + "trang-chu/thong-ke/thu.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Chi",
        code: "chi",
        link: config.mormanServer + "trang-chu/thong-ke/chi.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Tin nhắn đã gửi",
        code: "tinnhandagui",
        link: config.mormanServer + "trang-chu/thong-ke/thong-ke-tin-nhan.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Email đã gửi",
        code: "emaildagui",
        link: config.mormanServer + "trang-chu/thong-ke/thong-ke-email.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách hợp đồng bị xóa",
        code: "danhsachhopdongbixoa",
        link:
          config.mormanReact +
          "trang-chu/thong-ke/danh-sach-hop-dong-bi-xoa.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách thu bị xóa",
        code: "danhsachthubixoa",
        link:
          config.mormanReact + "trang-chu/thong-ke/danh-sach-thu-bi-xoa.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách chi bị xóa",
        code: "danhsachchibixoa",
        link:
          config.mormanReact + "trang-chu/thong-ke/danh-sach-chi-bi-xoa.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách kênh thanh toán",
        code: "thongke",
        link: config.mormanServer + "trang-chu/thong-ke/danh-sach-doi-tac.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thống kê theo kênh thanh toán",
        code: "thongke",
        link:
          config.mormanServer +
          "trang-chu/thong-ke/thong-ke-theo-kenh-thanh-toan.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý quỹ khác",
    code: "quanlyquykhac",
    link: config.mormanServer + "trang-chu/quy-khac.aspx",
    icon: "fas fa-donate font-menu",
  },
  {
    name: "Báo cáo",
    code: "baocao",
    link: "#baocao",
    icon: "fas fa-file-invoice-dollar font-menu",
    subItems: [
      {
        name: "Dòng tiền",
        code: "quytienmat",
        link: config.mormanServer + "trang-chu/bao-cao/quy-tien-mat.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Lợi nhuận",
        code: "loinhuan",
        link: config.mormanServer + "trang-chu/bao-cao/loi-nhuan.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Khách hàng gia tăng",
        code: "khachhanggiatang",
        link:
          config.mormanServer + "trang-chu/bao-cao/khach-hang-gia-tang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Dư nợ cho vay",
        code: "dunochovay",
        link: config.mormanServer + "trang-chu/bao-cao/du-no-cho-vay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Dư nợ huy động vốn",
        code: "dunonhanvay",
        link: config.mormanServer + "trang-chu/bao-cao/du-no-nhan-vay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Dư nợ giao nhân viên",
        code: "dunogiaonhanvien",
        link:
          config.mormanServer + "trang-chu/bao-cao/du-no-giao-nhan-vien.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Hợp đồng chờ duyệt",
        code: "hopdongchoduyet",
        link: config.mormanServer + "trang-chu/bao-cao/hop-dong-cho-duyet.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Giao dịch trong ngày",
        code: "giaodichtrongngay",
        link:
          config.mormanServer + "trang-chu/bao-cao/giao-dich-trong-ngay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Giao dịch chờ duyệt",
        code: "giaodichchoduyet",
        link:
          config.mormanServer + "trang-chu/bao-cao/giao-dich-cho-duyet.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Kiểm kê quỹ",
        code: "kiemkequy",
        link: config.mormanServer + "trang-chu/bao-cao/kiem-ke-quy.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách tất toán",
        code: "danhsachtattoan",
        link: config.mormanServer + "trang-chu/bao-cao/danh-sach-tat-toan.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Tất toán chờ duyệt",
        code: "tattoanchoduyet",
        link: config.mormanReact + "trang-chu/bao-cao/tat-toan-cho-duyet.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản trị hệ thống",
    code: "",
    link: "#quantrihethong",
    icon: "fas fa-cogs font-menu",
    subItems: [
      {
        name: "Cấu hình tài sản",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-tri-he-thong/cau-hinh-tai-san.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Cấu hình thống kê khách hàng",
        code: "cauhinhthongkekhachhang",
        link:
          config.mormanServer +
          "trang-chu/quan-tri-he-thong/cau-hinh-thong-ke-khach-hang.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Cấu hình tính lãi",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-he-thong/cau-hinh-tinh-lai.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Quản lý gói vay",
        code: "quanlygoivay",
        link: config.mormanReact + "/quan-ly-he-thong/quan-ly-goi-vay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Cấu hình bán hàng trả góp",
        code: "hethong_cauhinhbanhangtragop",
        link: config.mormanReact + "trang-chu/cau-hinh-ban-hang-tra-gop.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thuộc tính giảm trừ",
        code: "thuoctinhgiamtru",
        link:
          config.mormanServer +
          "/trang-chu/quan-ly-he-thong/thuoc-tinh-giam-tru.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Loại phiếu thu chi",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-tri-he-thong/loai-phieu-thu-chi.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Cấu hình Email",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-tri-he-thong/cau-hinh-email.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Cấu hình hệ thống",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-he-thong/cau-hinh-he-thong.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thỏa thuận sử dụng",
        code: "thoathuansudung",
        link:
          config.mormanReact +
          "trang-chu/quan-ly-he-thong/thoa-thuan-su-dung.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Quản lý log",
        code: "quantrihethong",
        link:
          config.mormanServer + "trang-chu/quan-tri-he-thong/quan-ly-log.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Quản lý mẫu hợp đồng",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-he-thong/quan-ly-mau-hop-dong.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Quản lý mẫu thu chi",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-ly-he-thong/quan-ly-mau-thu-chi.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Bảo trì dữ liệu",
        code: "quantrihethong",
        link:
          config.mormanServer +
          "trang-chu/quan-tri-he-thong/bao-tri-du-lieu.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Thông báo",
        code: "",
        link:
          config.mormanServer + "trang-chu/quan-tri-he-thong/thong-bao.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Menu",
        code: "",
        link: config.mormanServer + "trang-chu/quan-tri-he-thong/menu.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách IP",
        code: "",
        link:
          config.mormanServer + "trang-chu/quan-ly-mua-ban/danh-sach-ip.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Tích hợp ngân hàng",
    code: "tichhopbank",
    link: "#tichhopbank",
    icon: "mdi mdi-bank",
    subItems: [
      {
        name: "Tài khoản ngân hàng",
        code: "tichhopbank_danhsachtaikhoan",
        link: config.mormanReact + "bank/danhsach.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Lịch sử giao dịch",
        code: "tichhopbank_lichsugiaodich",
        link: config.mormanReact + "bank/lichsugiaodich.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách chờ TT",
        code: "tichhopbank_chothanhtoan",
        link: config.mormanReact + "bank/danhsachchothanhtoan.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quản lý ký số",
    code: "kyso",
    link: "#kyso",
    icon: "mdi mdi-bank",
    subItems: [
      {
        name: "Hợp đồng ký số",
        code: "danhsachhopdongkyso",
        link:
          config.mormanReact +
          "trang-chu/quan-ly-ky-so/danh-sach-hop-dong-ky-so.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "kiểm tra ký số",
        code: "kiemtrakyso",
        link:
          config.mormanReact + "trang-chu/quan-ly-ky-so/kiem-tra-ky-so.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
  {
    name: "Quy trình phê duyệt",
    code: "quytrinhpheduyet",
    link: "#quytrinhpheduyet",
    icon: "fas fa-cogs font-menu",
    subItems: [
      {
        name: "Quản lý gói vay",
        code: "quanlygoivay",
        link: config.mormanReact + "/quan-ly-he-thong/quan-ly-goi-vay.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Phân quyền tạo duyệt",
        code: "quytrinhpheduyet_phanquyentaoduyet",
        link: config.mormanReact + "/pheduyet/phan-quyen-tao-duyet.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Phân quyền duyệt",
        code: "quytrinhpheduyet_phanquyenpheduyet",
        link: config.mormanReact + "/pheduyet/phan-quyen-duyet.aspx",
        icon: "fas fa-caret-right",
      },
      {
        name: "Danh sách chờ duyệt",
        code: "quytrinhpheduyet_hopdongchopheduyet",
        link:
          config.mormanReact +
          "/trang-chu/bao-cao/hop-dong-cho-duyet_phe_duyet.aspx",
        icon: "fas fa-caret-right",
      },
    ],
  },
];
export const ListMenuIcon = {
  trangchu: "fas fa-home font-menu",
  baocaotongquan: "fas fa-chart-bar font-menu",
  nophaithu: "fas fa-comment-dollar font-menu",
  dongtiennhanh: "fas fa-comment-dollar font-menu",
  camdo: "la la-share-alt",
  laingay: "la la-share-alt",
  laiho: "la la-share-alt",
  banhangtragop: "la la-share-alt",
  quanlymuaban: "fas fa-home font-menu",
  quanlykhachhang: "far fa-address-card font-menu",
  quanlydacuahang: "fas fa-home font-menu",
  danhsachnoxau: "fas fa-home font-menu",
  quanlytaisan: "fas fa-car-side font-menu",
  quanlynhanvien: "fas fa-users-cog font-menu",
  quanlythuchi: "fas fa-coins font-menu",
  quanlynguonvonnew: "fas fa-donate font-menu",
  thongke: "fas fa-chart-line font-menu",
  quanlyquykhac: "fas fa-donate font-menu",
  baocao: "fas fa-file-invoice-dollar font-menu",
  quantrihethong: "fas fa-cogs font-menu",
  tichhopbank: "mdi mdi-bank",
  quytrinhpheduyet: "fas fa-cogs font-menu",
  danhsachnoxau: "la la-share-alt",
};
export const ListMenuReact = {
  ListMenuCode: [
    "nophaithu",
    "camdo",
    "laingay",
    "danhsachnoxaucamdo",
    "danhsachnoxautinchap",
    "danhsachnoxautragop",
    "laiho",
    "danhsachkho",
    "danhsachtaisan",
    "congnothanhly",
    "danhsachthanhly",
    "kiemkho",
    "danhsachkiemkho",
    "dunochovay",
    "dunogiaonhanvien",
    "hopdongchoduyet",
    "dunonhanvay",
    "danhsachthubixoa",
    "danhsachchibixoa",
    "danhsachhopdongbixoa",
    "quanlynguonvonnew",
    "thuchingoaile",
    "thuchihopdong",
    "trichlapduphong",
    "danhsachdangkyvay",
    "dulieudamua",
    "baocaotongquan",
    "banhangtragop",
    "banhangtragop",
    "hethong_cauhinhbanhangtragop",
    "banhangtragop_cauhinh",
    "tichhopbank_lichsugiaodich",
    "tichhopbank_danhsachtaikhoan",
    "tichhopbank_chothanhtoan",
    "quanlygoivay",
    "quytrinhpheduyet_hopdongchopheduyet",
    "quytrinhpheduyet_phanquyenpheduyet",
    "quytrinhpheduyet_phanquyentaoduyet",
    "tattoanchoduyet",
    "danhsachnoxaucamdo",
    "danhsachnoxautinchap",
    "danhsachnoxautragop",
    "taikhoanicloud_danhsach",
    "quanlygoivay",
    "danhsachhopdongkyso",
    "kiemtrakyso",
  ],
};

export default ListMenu;
